import WasteUpsell from "components/UpsellLandingPages/WasteUpsell";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { Outlet } from "react-router-dom";

export function Waste() {
  const { featureFlags: flags, loading } = useFeatureFlags();
  const { isStaff, loading: userLoading } = useCurrentUser();
  const hasWaste = flags[FeatureFlagKey.WasteModule];

  if (loading || userLoading) {
    return null;
  }

  if (!hasWaste && !isStaff) {
    return <WasteUpsell />;
  }

  return <Outlet />;
}
